import { render, staticRenderFns } from "./CreateContractorCategory.vue?vue&type=template&id=b0bd53d2&scoped=true"
import script from "./CreateContractorCategory.vue?vue&type=script&lang=js"
export * from "./CreateContractorCategory.vue?vue&type=script&lang=js"
import style0 from "./CreateContractorCategory.vue?vue&type=style&index=0&id=b0bd53d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bd53d2",
  null
  
)

export default component.exports